// Klijentska logika dijaloga "Neoporezivi primici" - ZRCALO funkcija iz server/helpers/neoporezivo.js
// (ocijeniKategoriju, sukobPrehrane, limitDogadaja, ocijeniDogadaj, sastaviPrijenos).
// Limiti i kategorije NE zive ovdje nego dolaze s servera (GET /salarie/neoporezivo); ovdje je samo racun.
// Mijenjati OBJE strane zajedno; server/helpers/neoporezivo.mirror.test.js provjerava da daju iste rezultate.

const num = (v) => parseFloat(v) || 0
export const r2 = (v) => Math.round((num(v) + Number.EPSILON) * 100) / 100

export const oznakaTekst = (n) => n === 5 ? '05' : String(n)
export const daniUMjesecu = (godina, mjesec) => new Date(godina, mjesec + 1, 0).getDate() // mjesec 0-11

export const jubilarniIznos = (godine, jubilarne) => {
  const g = parseInt(godine) || 0
  let iznos = null
  ;(jubilarne || []).forEach(j => { if (g >= j[0]) iznos = j[1] })
  return iznos
}
export const jeJubilarnaGodina = (godine) => {
  const g = parseInt(godine) || 0
  return g >= 10 && (g === 10 || g % 5 === 0)
}

// s: { iskGod, iskMjesec, unos, godina, mjesec (0-11), nadoplata, brojDjece }
export const ocijeniKategoriju = (kat, s) => {
  const unos = Math.max(0, num(s.unos))
  const iskGod = r2(s.iskGod)
  const iskMjesec = r2(s.iskMjesec)
  const djece = Math.max(1, parseInt(s.brojDjece) || 1)
  const out = { oznaka: kat.oznaka, limit: null, limitMj: null, limitGod: null, bezLimita: false, iskoristeno: iskGod, preostalo: null,
    nakon: r2(iskGod + unos), visak: 0, vrstaVisaka: '', poruke: [] }
  if (kat.grupa === 'godisnji') {
    const limit = kat.limitGod == null ? null : r2(kat.limitGod * (kat.poDjetetu ? djece : 1))
    out.limit = out.limitGod = limit
    if (limit == null) { out.bezLimita = true; return out }
    out.preostalo = r2(Math.max(0, limit - iskGod))
    out.visak = r2(Math.max(0, Math.min(unos, iskGod + unos - limit)))
    if (out.visak) { out.vrstaVisaka = 'limit'; out.poruke.push('prelazi limit za ' + out.visak.toFixed(2) + ' €') }
    return out
  }
  let limMj = kat.limitDan ? r2(kat.limitDan * daniUMjesecu(s.godina, s.mjesec)) : (kat.limitMj == null ? null : kat.limitMj)
  const limGod = kat.limitGod == null ? null : kat.limitGod
  out.limitGod = limGod
  const nadoplata = !!(kat.nadoplata && s.nadoplata && s.mjesec === 11)
  out.nadoplata = nadoplata
  let vMj = 0
  let vGod = 0
  if (nadoplata) {
    limMj = null
    out.preostalo = r2(Math.max(0, limGod - iskGod))
  } else if (limMj != null) {
    vMj = r2(Math.max(0, Math.min(unos, iskMjesec + unos - limMj)))
  }
  out.limitMj = limMj
  if (limGod != null) {
    vGod = r2(Math.max(0, Math.min(unos, iskGod + unos - limGod)))
    if (out.preostalo == null) out.preostalo = r2(Math.max(0, limGod - iskGod))
  }
  out.limit = limMj != null ? limMj : limGod
  out.bezLimita = limMj == null && limGod == null
  if (limMj != null && out.preostalo == null) out.preostalo = r2(Math.max(0, limMj - iskMjesec))
  out.visak = Math.max(vMj, vGod)
  if (out.visak) {
    out.vrstaVisaka = vMj >= vGod ? 'mjesečni limit' : 'godišnji limit'
    if (nadoplata) out.vrstaVisaka = 'preostalu razliku do godišnjeg limita'
    out.poruke.push('prelazi ' + out.vrstaVisaka + ' za ' + out.visak.toFixed(2) + ' €')
  }
  return out
}

export const sukobPrehrane = (isk65Mj, unos65, isk66Mj, unos66) => (num(isk65Mj) + num(unos65)) > 0 && (num(isk66Mj) + num(unos66)) > 0

export const limitDogadaja = (tip, kol, iskGodisnje, jubilarne) => {
  if (tip.jubilarna) {
    const j = jubilarniIznos(kol, jubilarne)
    return j == null ? 0 : j
  }
  if (tip.jedinica == null) return null
  const k = Math.max(1, parseInt(kol) || 1)
  const lim = tip.mnozi ? r2(tip.jedinica * (tip.id === 'km' ? Math.max(0, num(kol)) : k)) : tip.jedinica
  return tip.godisnje ? r2(Math.max(0, lim - num(iskGodisnje))) : lim
}

export const ocijeniDogadaj = (tip, kol, iznos, iskGodisnje, jubilarne) => {
  const limit = limitDogadaja(tip, kol, iskGodisnje, jubilarne)
  const unos = Math.max(0, num(iznos))
  const out = { limit, bezLimita: limit == null, visak: 0, poruke: [] }
  if (limit != null) out.visak = r2(Math.max(0, unos - limit))
  if (tip.jubilarna) {
    const g = parseInt(kol) || 0
    if (g < 10) out.poruke.push('jubilarna nagrada: staž manji od 10 godina, nema prava na neoporezivu nagradu')
    else if (!jeJubilarnaGodina(g)) out.poruke.push('jubilarna nagrada isplaćuje se kad se navrši 10 godina staža i svake sljedeće 5.; ' + g + ' nije jubilarna godina')
  }
  if (out.visak) out.poruke.push('prelazi limit događaja za ' + out.visak.toFixed(2) + ' €')
  return out
}

export const sastaviPrijenos = (linije, odluke, maxStavki) => {
  const od = odluke || {}
  const neoporezivo = []
  const ceka = []
  const odobreno = []
  const odbijeno = []
  ;(linije || []).forEach(l => {
    const iznos = r2(l.iznos)
    if (!(iznos > 0)) return
    const visak = Math.min(iznos, r2(l.visak))
    const dop = r2(iznos - visak)
    if (dop > 0) neoporezivo.push({ kljuc: l.kljuc, opis: l.opis, oznaka: l.oznaka, kolona: l.kolona || '15.1', iznos: dop })
    if (visak > 0) {
      const red = { kljuc: l.kljuc, opis: l.opis, oznaka: l.oznaka, iznos: visak }
      if (od[l.kljuc] === 'odobri') odobreno.push(red)
      else if (od[l.kljuc] === 'odbij') odbijeno.push(red)
      else ceka.push(red)
    }
  })
  const zbroj = (a) => r2(a.reduce((s, x) => s + x.iznos, 0))
  const out = {
    neoporezivo, ceka, odobreno, odbijeno,
    zbrojNeoporezivo: zbroj(neoporezivo), zbrojCeka: zbroj(ceka), zbrojOdobreno: zbroj(odobreno), zbrojOdbijeno: zbroj(odbijeno),
    brojNerijesenih: ceka.length
  }
  out.mozeSePrenijeti = neoporezivo.length + odobreno.length > 0 && ceka.length === 0
  out.stavkeZaFormu = neoporezivo
  out.previseStavki = neoporezivo.length > (maxStavki || 5)
  out.uputa = ceka.length
    ? 'Riješi ' + ceka.length + (ceka.length === 1 ? ' višak' : ' viškova') + ': odobri ili odbij.'
    : ''
  out.potvrdaViska = odobreno.length ? zbroj(odobreno) : 0
  return out
}
